package com.xtream.composeapp.viewmodel


import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.composeapp.domain.sealed.ApiSealed
import com.xtream.data_kmp.db.repo.UserRepo
import com.xtream.data_kmp.dto.Ad
import com.xtream.data_kmp.remote.createApiService
import com.xtream.data_kmp.util.exception.getErrorMessage
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch


class AdViewModel (
    private val userRepo: UserRepo,
    ) : ViewModel()  {



    var bannerState by mutableStateOf<ApiSealed<Ad>>(ApiSealed.Loading)
    private val coroutineExceptionHandler = CoroutineExceptionHandler { _, throwable ->
        throwable.printStackTrace()
    }

    fun loadAd(type: String?) {

        viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            if (userRepo.getLastLoggedInUser()?.userInfo?.isTrial == "0")
                return@launch


            bannerState = ApiSealed.Loading
            try {
                val client = createApiService(SharedBuildKonfig.AD_SERVER)
                val adResponse =
                    if (type.isNullOrEmpty())
                        client.getSponsorBanner()
                    else client.getBanner(type)

                bannerState = ApiSealed.Success(adResponse)
             //   Log.d("AdViewModel", "loadAd: $adResponse")
            } catch (e: Exception) {
                val msg = e.getErrorMessage()
                bannerState = ApiSealed.Error(msg)
            }

        }
    }

}

